<template>
  <div class="intro-wrapper">
    <div ref="bcg" class="bcg-wrapper" />
  </div>
</template>

<script>
import gsap from 'gsap'

export default {
  computed: {
    initialSlide() {
      return this.$store.state.initSlideIdxFromUrlOnDesktop
    },
    currentSlide() {
      return this.$store.state.currentSlide
    }
  },
  watch: {
    '$store.getters.isPageLoaded'(value) {
      if (value && !this.$store.getters.isAnyPopupOpen) this.enterAnimation()
    },
    '$store.state.isGateOpen'(value) {
      if (!value) this.enterAnimation()
    },
    '$store.state.isMobileMenuOpen'(value) {
      if (value) {
        // reset animation on mobile enter
        setTimeout(() => {
          this.animateMobileIntro('leave')
        }, 500)
      } else {
        this.animateMobileIntro('enter', !!this.currentSlide)
      }
    }
  },
  methods: {
    enterAnimation() {
      if (this.initialSlide) {
        // initial not-intro section
        this.hideBottle()
      }

      setTimeout(() => {
        this.animateMobileIntro('enter', this.initialSlide)
      }, 500)
    },
    animateMobileIntro(direction = 'enter', hideBottle = false) {
      const { bcg } = this.$refs
      const button = document.querySelector('.gsap-mobile-button')
      const bottle = document.querySelector('.bottle-wrapper--mobile-intro')
      const tl = gsap.timeline()

      if (direction === 'enter') {
        tl.addLabel('enter')
          .set(bottle, { opacity: hideBottle ? 0 : 1 })
          .to(bcg, {
            height: '90%',
            duration: 0.6,
            ease: 'power2.easeOut'
          })
          .to(
            bottle,
            {
              y: hideBottle ? '-150vh' : '-40vh',
              duration: 0.6,
              ease: 'back.easeOut'
            },
            'enter'
          )
          .to(
            button,
            {
              opacity: 1,
              duration: 0.6,
              ease: 'back.easeOut'
            },
            'enter'
          )
          .set(bottle, { opacity: 1 })
      } else {
        tl.set([bcg, bottle, button], { clearProps: 'all' })
      }
    },
    hideBottle() {
      const bottle = document.querySelector('.bottle-wrapper--mobile-intro')
      const tl = gsap.timeline()

      tl.set(bottle, { opacity: 0 })
        .to(bottle, { y: '-150vh', duration: 0.1 })
        .set(bottle, { opacity: 1 })
    }
  }
}
</script>

<style lang="scss" scoped>
.intro-wrapper {
  width: 100%;
  max-height: 100%;
  height: 100%;
  position: relative;
}

.bcg-wrapper {
  width: 100%;
  max-height: 100%;
  height: 100%;

  background-image: url('/images/intro_md.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  @include media-down(md) {
    background-image: url('/images/intro_sm.png');
  }
}
</style>
